{
    "TelephoneserverLabel": "Server telefonico:",
    "PartitionsLabel": "Partizione\/i:",
    "ScopeFiltering_SectionHeader": "Filtraggio dell'ambito",
    "NAME": "ScopeFiltering",
    "ScopeGroupsLabel": "Gruppo(i) di ambito:",
    "AnyScopeGroupsLabel": "[Qualsiasi gruppo di ambito]"
}